import { combineReducers } from "redux";

import divisionList from "./divisionList";
import divisionDetails from "./divisionDetails";

import divisionPermissions from "./divisionPermissions";
import divisionRoles from "./divisionRoles";
import divisionRoleDetails from "./divisionRoleDetails";
import divisionUsers from "./divisionUsers";
import divisionSystems from "./divisionSystems";
import divisionManufacturers from "./divisionManufacturers";

export default combineReducers({
  divisionList,
  divisionDetails,
  divisionRoles,
  divisionRoleDetails,
  divisionUsers,
  divisionPermissions,
  divisionSystems,
  divisionManufacturers,
});

export * from "./divisionList";
export * from "./divisionDetails";

export * from "./divisionPermissions";
export * from "./divisionRoles";
export * from "./divisionRoleDetails";
export * from "./divisionUsers";
export * from "./divisionSystems";
export * from "./divisionManufacturers";
